import React, { Component } from "react";
import Select from "react-select";
import Utils from "../../utils.js";

class ConsumerName extends Component {
  consumerMissingEnv = [];
  productMissingEnv = [];
  selectedTestItem = false;
  selectedPilotItem = false;
  selectedProdItem = false;
  selectedTestItemPending = false;
  selectedPilotItemPending = false;
  selectedProdItemPending = false;

  constructor(props) {
    super(props);
    this.state = {
      buildEnvironmentError: false,
      baseEnvironment: "",
      singleEnv: "",
      singleEnvError: false,
      multiEnv: [],
      multiEnvError: false,
      singleProductEnv: "",
      singleProductEnvError: false,
      multiProductEnv: [],
      multiProductEnvError: false,
      prodConsumers: [],
      testConsumers: [],
      pilotConsumers: [],
      selectedOption: null,
      consumers: [],
      consumerNotPresentMainError: false,
      productPendingError: false,
      productPendingEnvs: "",
      isLoadingConsumers: true,
    };
    this.identity = `ConsumerNameInstance@${this.props.id}`;
  }
  isValidated() {
    if (this.state.selectedOption == null) {
      return false;
    }
    if (
      this.state.singleProductEnvError === true ||
      this.state.multiProductEnvError === true
    ) {
      return false;
    }
    if (this.state.productPendingError === true) {
      return false;
    }
    if (this.state.consumerNotPresentMainError === true) {
      return false;
    }
    if (
      this.state.singleEnvError === true ||
      this.state.multiEnvError === true
    ) {
      return false;
    }
    if (this.state.selectedOption == null) {
      return false;
    }
    if (
      this.state.selectedOption !== null &&
      this.isProblemConsumer() === true
    ) {
      return false;
    }
    if (
      this.state.selectedOption !== null &&
      Utils.isDuplicateConsumer(
        this.props.getStore().consumerName,
        this.state.prodConsumers
      ) === true
    ) {
      return false;
    }
    if (this.state.consumerNotPresentError === true) {
      return false;
    }
  }
  componentDidMount() {
    //Resetting previous selection on load
    this.props.updateStore({ consumerName: "", appId: "" });

    // let saved = this.props.getStore()[this.identity];
    // if(saved) {
    // 	this.setState(saved);
    // }
    // else {
    const apiName = 'Get Apigee Info API';
    const apiPaths = [
      "/prod/overview",
      "/test/overview",
      "/pilot/overview",
    ];
    const fetchPromises = apiPaths.map((path) =>
      Utils.fetchLambdaApis(apiName, path, null)
        .then((json) =>
          Object.values(json.apps).map((e) => ({
            label: e.displayName || e.name,
            value: e.appId,
            products: e.products,
          }))
        )
        .catch(error => {
          console.error(`Error fetching from ${path}:`, error);
          return [];
        })
    );
    Promise.all(fetchPromises)
      .then(([prod, test, pilot]) => {
        this.setState(
          {
            prodConsumers: prod,
            testConsumers: test,
            pilotConsumers: pilot,
          },
          () => {
            // Process and sort consumers after state is set
            this.setFilteredConsumers();
            this.setState({ isLoadingConsumers: false });
          }
        );
      })
      .catch((error) => {
        console.log("error fetching data:", error);
        this.setState({ isLoadingConsumers: false });
      });

    //}
  }
  componentWillUnmount() {
    let state = {};
    state[this.identity] = this.state;
    this.props.updateStore(state);
  }

  setFilteredConsumers = () => {
    let selectedEnvs = [];
    const { prodConsumers, testConsumers, pilotConsumers } = this.state;

    if (
      null !== this.props.getStore().buildEnvironment &&
      this.props.getStore().buildEnvironment.length > 0
    ) {
      selectedEnvs = this.props.getStore().buildEnvironment.split(",");

      if (null !== selectedEnvs && selectedEnvs.length === 1) {
        if (selectedEnvs.includes("PRODUCTION")) {
          if (null === prodConsumers || prodConsumers.length === 0) {
            this.setState({
              consumerNotPresentError: true,
              singleEnv: "PRODUCTION",
            });
          }
          const sortedProd = [...prodConsumers].sort((a, b) =>
            a.label.localeCompare(b.label)
          );
          this.setState({ consumers: sortedProd });
          this.setState({ baseEnvironment: "PRODUCTION" });
        } else if (selectedEnvs.includes("PILOT")) {
          if (null === pilotConsumers || pilotConsumers.length === 0) {
            this.setState({
              consumerNotPresentMainError: true,
              singleEnv: "PILOT",
            });
          }
          const sortedPilot = [...pilotConsumers].sort((a, b) =>
            a.label.localeCompare(b.label)
          );
          this.setState({ consumers: sortedPilot });
          this.setState({ baseEnvironment: "PILOT" });
        } else if (selectedEnvs.includes("TEST")) {
          if (null === testConsumers || testConsumers.length === 0) {
            this.setState({
              consumerNotPresentMainError: true,
              singleEnv: "TEST",
            });
          }
          const sortedTest = [...testConsumers].sort((a, b) =>
            a.label.localeCompare(b.label)
          );
          this.setState({ consumers: sortedTest });
          this.setState({ baseEnvironment: "TEST" });
        }
      } else if (null !== selectedEnvs && selectedEnvs.length > 1) {
        if (selectedEnvs.includes("PRODUCTION")) {
          if (null === prodConsumers || prodConsumers.length === 0) {
            this.setState({
              consumerNotPresentMainError: true,
              singleEnv: "PRODUCTION",
            });
          }
          const sortedProd = [...prodConsumers].sort((a, b) =>
            a.label.localeCompare(b.label)
          );
          this.setState({ baseEnvironment: "PRODUCTION" });
          this.setState({ consumers: sortedProd });
        } else if (selectedEnvs.includes("PILOT")) {
          if (null === pilotConsumers || pilotConsumers.length === 0) {
            this.setState({
              consumerNotPresentMainError: true,
              singleEnv: "PILOT",
            });
          }
          const sortedPilot = [...pilotConsumers].sort((a, b) =>
            a.label.localeCompare(b.label)
          );
          this.setState({ baseEnvironment: "PILOT" });
          this.setState({ consumers: sortedPilot });
        }
      }
    }
  };

  isProblemConsumer() {
    if (this.props.getStore().consumerName === "RIS-FSA_Sponsor") {
      return true;
    } else {
      return false;
    }
  }

  // Simple virtualization component for better dropdown performance
  // Works without external dependencies and compatible with React 16
  MenuList = (props) => {
    const { children, maxHeight } = props;

    if (!children || !Array.isArray(children) || children.length === 0) {
      return null;
    }

    // For small lists, render normally
    if (children.length <= 100) {
      return <div style={{ maxHeight, overflowY: "auto" }}>{children}</div>;
    }

    // For large lists, use simple virtualization
    // Only render first 100 items initially for better performance
    const visibleChildren = children.slice(0, 100);
    const hasMore = children.length > 100;

    return (
      <div style={{ maxHeight, overflowY: "auto" }}>
        {visibleChildren}
        {hasMore && (
          <div
            style={{
              padding: "8px",
              textAlign: "center",
              fontSize: "12px",
              color: "#666",
            }}
          >
            Showing first 100 of {children.length} results. Type to search for
            more.
          </div>
        )}
      </div>
    );
  };

  // Optimized filter for better search performance
  filterOption = (option, inputValue) => {
    if (!inputValue) return true;
    return option.label.toLowerCase().includes(inputValue.toLowerCase());
  };

  checkConsumerBySelectedEnv = (
    consumer,
    consumerList1Array,
    consumerList2Array,
    count,
    removeBaseEnvArr
  ) => {
    const consumerList1 = consumerList1Array.map((consumer) => consumer.label);
    let consumerList2 = [];
    if (null !== consumerList2Array) {
      consumerList2 = consumerList2Array.map((consumer) => consumer.label);
    }

    if (count === 1) {
      if (consumer === "") {
        return false;
      }
      if (!consumerList1.includes(consumer)) {
        this.setState({ singleEnvError: true });
        this.props.updateStore({ isSubmit: true });
        this.setState({ singleEnv: removeBaseEnvArr });
        return false;
      }
    } else if (count === 2) {
      if (!consumerList1.includes(consumer) && removeBaseEnvArr === "TEST") {
        this.consumerMissingEnv.push("TEST");
        this.setState({ multiEnv: this.consumerMissingEnv });
      }
      if (!consumerList2.includes(consumer) && removeBaseEnvArr === "PILOT") {
        this.consumerMissingEnv.push("PILOT");
        this.setState({ multiEnv: this.consumerMissingEnv.join(",") });
      }
      if (
        null !== this.consumerMissingEnv &&
        this.consumerMissingEnv.length > 0
      ) {
        this.setState({ multiEnvError: true });
        this.props.updateStore({ isSubmit: true });
      }
    }
  };

  checkIfProductIsInConsumerBySelectedEnv = (
    productName,
    isTest,
    isPilot,
    isProd
  ) => {
    this.setState({
      multiProductEnvError: false,
      singleProductEnvError: false,
    });
    this.props.updateStore({ isSubmit: false });

    if (this.state.consumerNotPresentMainError === false) {
      let selectedEnvs = this.props.getStore().buildEnvironment.split(",");
      if (isTest === true) {
        if (
          !this.productMissingEnv.includes("TEST") &&
          selectedEnvs.includes("TEST")
        ) {
          this.productMissingEnv.push("TEST");
        }
      }
      if (isPilot === true) {
        if (
          !this.productMissingEnv.includes("PILOT") &&
          selectedEnvs.includes("PILOT")
        ) {
          this.productMissingEnv.push("PILOT");
        }
      }
      if (isProd === true) {
        if (
          !this.productMissingEnv.includes("PRODUCTION") &&
          selectedEnvs.includes("PRODUCTION")
        ) {
          this.productMissingEnv.push("PRODUCTION");
        }
      }
      if (
        null !== this.productMissingEnv &&
        this.productMissingEnv.length === 3
      ) {
        this.setState({ singleProductEnvError: true });
        this.props.updateStore({ isSubmit: true });
      } else if (
        null !== this.productMissingEnv &&
        this.productMissingEnv.length > 0
      ) {
        this.setState({ singleProductEnvError: false });
        for (let i = 0; i < this.productMissingEnv.length; i++) {
          if (selectedEnvs.includes(this.productMissingEnv[i])) {
            this.setState({
              multiProductEnv: this.productMissingEnv.join(","),
            });
          }
        }
        this.setState({ multiProductEnvError: true });
        this.props.updateStore({ isSubmit: true });
      }
    } else {
      this.setState({
        multiProductEnvError: false,
        singleProductEnvError: false,
      });
      this.props.updateStore({ isSubmit: false });
    }
  };

  checkIfProductIsInPendingState = (
    selectedEnvs,
    isTestPending,
    isPilotPending,
    isProdPending
  ) => {
    let pendingEnvironments = [];
    if (isTestPending && selectedEnvs.includes("TEST")) {
      pendingEnvironments.push("TEST");
    }
    if (isPilotPending && selectedEnvs.includes("PILOT")) {
      pendingEnvironments.push("PILOT");
    }
    if (isProdPending && selectedEnvs.includes("PRODUCTION")) {
      pendingEnvironments.push("PRODUCTION");
    }

    if (pendingEnvironments.length > 0) {
      this.setState({
        productPendingError: true,
        productPendingEnvs: pendingEnvironments.join(", "),
      });
      this.props.updateStore({ isSubmit: true });
    } else {
      this.setState({
        productPendingError: false,
        productPendingEnvs: "",
      });
    }
  };

  fetchConsumer = async (productName, consumerName, env) => {
    try {
      const apiName = 'Get Apigee Info API';

      // Map environment to Lambda API paths
      const envPathMap = {
        "PRODUCTION": `/prod/apps/${consumerName}`,
        "PILOT": `/pilot/apps/${consumerName}`,
        "TEST": `/test/apps/${consumerName}`
      };

      const path = envPathMap[env];
      const json = await Utils.fetchLambdaApis(apiName, path, null);

      let productFound = false;

      if (env === "TEST") {
        // Check regular products first
        let arrayTest = json.products;
        if (null !== arrayTest && arrayTest.length > 0) {
          for (let i = 0; i < arrayTest.length; i++) {
            if (productName === arrayTest[i]) {
              this.selectedTestItem = true;
              productFound = true;
              break;
            }
          }
        }

        // If not found in products, check pending_products
        if (!productFound) {
          let pendingArrayTest = json.pending_products;
          if (null !== pendingArrayTest && pendingArrayTest.length > 0) {
            for (let i = 0; i < pendingArrayTest.length; i++) {
              if (productName === pendingArrayTest[i]) {
                this.selectedTestItemPending = true;
                break;
              }
            }
          }
        }
      } else if (env === "PILOT") {
        // Check regular products first
        const arrayPilot = json.products;
        if (null !== arrayPilot && arrayPilot.length > 0) {
          for (let i = 0; i < arrayPilot.length; i++) {
            if (productName === arrayPilot[i]) {
              this.selectedPilotItem = true;
              productFound = true;
              break;
            }
          }
        }

        // If not found in products, check pending_products
        if (!productFound) {
          let pendingArrayPilot = json.pending_products;
          if (null !== pendingArrayPilot && pendingArrayPilot.length > 0) {
            for (let i = 0; i < pendingArrayPilot.length; i++) {
              if (productName === pendingArrayPilot[i]) {
                this.selectedPilotItemPending = true;
                break;
              }
            }
          }
        }
      } else if (env === "PRODUCTION") {
        // Check regular products first
        const arrayProd = json.products;
        if (null !== arrayProd && arrayProd.length > 0) {
          for (let i = 0; i < arrayProd.length; i++) {
            if (productName === arrayProd[i]) {
              this.selectedProdItem = true;
              productFound = true;
              break;
            }
          }
        }

        // If not found in products, check pending_products
        if (!productFound) {
          let pendingArrayProd = json.pending_products;
          if (null !== pendingArrayProd && pendingArrayProd.length > 0) {
            for (let i = 0; i < pendingArrayProd.length; i++) {
              if (productName === pendingArrayProd[i]) {
                this.selectedProdItemPending = true;
                break;
              }
            }
          }
        }
      }
    } catch (error) {
      console.error(`Error fetching consumer ${consumerName} in ${env}:`, error);
    }
  };

  //lambda ensures correct 'this' scope
  onChange = async (selectedOption) => {
    this.setState({
      selectedOption: selectedOption,
    });

    this.setState({ multiEnvError: false });
    this.setState({ singleEnvError: false });
    this.setState({ consumerNotPresentError: false });
    const consumerName = selectedOption.label;
    const productName = this.props.getStore().productName;

    // Build environment-specific appId object
    const appIdsByEnv = {};

    const selectedConsumerTestItem = this.state.testConsumers.find(
      (item) => item.label === consumerName
    );

    const selectedConsumerPilotItem = this.state.pilotConsumers.find(
      (item) => item.label === consumerName
    );

    const selectedConsumerProdItem = this.state.prodConsumers.find(
      (item) => item.label === consumerName
    );

    // Collect appIds for environments where consumer exists
    if (selectedConsumerTestItem) {
      appIdsByEnv.TEST = selectedConsumerTestItem.value;
    }
    if (selectedConsumerPilotItem) {
      appIdsByEnv.PILOT = selectedConsumerPilotItem.value;
    }
    if (selectedConsumerProdItem) {
      appIdsByEnv.PRODUCTION = selectedConsumerProdItem.value;
    }

    // Store initial appId object (will be filtered later based on validations)
    this.props.updateStore({
      consumerName: consumerName,
      appId: JSON.stringify(appIdsByEnv),
    });

    this.selectedTestItem = false;
    this.selectedPilotItem = false;
    this.selectedProdItem = false;
    this.selectedTestItemPending = false;
    this.selectedPilotItemPending = false;
    this.selectedProdItemPending = false;
    this.productMissingEnv = [];

    if (
      null !== selectedConsumerTestItem &&
      undefined !== selectedConsumerTestItem
    ) {
      await this.fetchConsumer(
        productName,
        selectedConsumerTestItem.value,
        "TEST"
      );
    }

    if (
      null !== selectedConsumerPilotItem &&
      undefined !== selectedConsumerPilotItem
    ) {
      await this.fetchConsumer(
        productName,
        selectedConsumerPilotItem.value,
        "PILOT"
      );
    }

    if (
      null !== selectedConsumerProdItem &&
      undefined !== selectedConsumerProdItem
    ) {
      await this.fetchConsumer(
        productName,
        selectedConsumerProdItem.value,
        "PRODUCTION"
      );
    }

    let selectedEnvs = this.props.getStore().buildEnvironment.split(",");

    if (null !== selectedEnvs && selectedEnvs.length >= 2) {
      // remove the base environment from list
      const removeBaseEnvArr = selectedEnvs.filter(
        (item) => item !== this.state.baseEnvironment
      );

      if (removeBaseEnvArr.length === 1) {
        if (removeBaseEnvArr.includes("PILOT")) {
          this.checkConsumerBySelectedEnv(
            consumerName,
            this.state.pilotConsumers,
            null,
            1,
            removeBaseEnvArr
          );
          this.checkIfProductIsInConsumerBySelectedEnv(
            productName,
            this.selectedTestItem,
            this.selectedPilotItem,
            this.selectedProdItem
          );
        } else if (removeBaseEnvArr.includes("TEST")) {
          this.checkConsumerBySelectedEnv(
            consumerName,
            this.state.testConsumers,
            null,
            1,
            removeBaseEnvArr
          );
          this.checkIfProductIsInConsumerBySelectedEnv(
            productName,
            this.selectedTestItem,
            this.selectedPilotItem,
            this.selectedProdItem
          );
        }
      }
      if (removeBaseEnvArr.length > 1) {
        this.consumerMissingEnv = [];

        for (let i = 0; i < removeBaseEnvArr.length; i++) {
          this.checkConsumerBySelectedEnv(
            consumerName,
            this.state.testConsumers,
            this.state.pilotConsumers,
            2,
            removeBaseEnvArr[i]
          );
          this.checkIfProductIsInConsumerBySelectedEnv(
            productName,
            this.selectedTestItem,
            this.selectedPilotItem,
            this.selectedProdItem
          );
        }
      }

      // Check for pending products after all consumer validations
      this.checkIfProductIsInPendingState(
        selectedEnvs,
        this.selectedTestItemPending,
        this.selectedPilotItemPending,
        this.selectedProdItemPending
      );

      // Ensure appId is stored with environment-specific values
      this.props.updateStore({
        consumerName: consumerName,
        appId: JSON.stringify(appIdsByEnv),
      });

    } else {
      if (selectedEnvs.includes("PRODUCTION")) {
        this.checkConsumerBySelectedEnv(
          consumerName,
          this.state.prodConsumers,
          null,
          1,
          "PRODUCTION"
        );
        this.checkIfProductIsInConsumerBySelectedEnv(
          productName,
          this.selectedTestItem,
          this.selectedPilotItem,
          this.selectedProdItem
        );
      } else if (selectedEnvs.includes("PILOT")) {
        this.checkConsumerBySelectedEnv(
          consumerName,
          this.state.pilotConsumers,
          null,
          1,
          "PILOT"
        );
        this.checkIfProductIsInConsumerBySelectedEnv(
          productName,
          this.selectedTestItem,
          this.selectedPilotItem,
          this.selectedProdItem
        );
      } else {
        this.checkConsumerBySelectedEnv(
          consumerName,
          this.state.testConsumers,
          null,
          1,
          "TEST"
        );
        this.checkIfProductIsInConsumerBySelectedEnv(
          productName,
          this.selectedTestItem,
          this.selectedPilotItem,
          this.selectedProdItem
        );
      }

      // Check for pending products after all consumer validations
      this.checkIfProductIsInPendingState(
        selectedEnvs,
        this.selectedTestItemPending,
        this.selectedPilotItemPending,
        this.selectedProdItemPending
      );
    }
  };
  render() {
    return (
      <div>
        <div className="container">
          <br />
          <div className="row">
            <div className="col-md-8">
              <label htmlFor="consumerName">Consumer Name</label>
              <p>
                API Gateway name of the calling application (Filtered from{" "}
                {this.state.baseEnvironment}).
              </p>
              {this.state.isLoadingConsumers ? (
                <div className="text-center" style={{ padding: "20px" }}>
                  <div
                    className="spinner-border text-primary"
                    role="status"
                    style={{ width: "3rem", height: "3rem" }}
                  >
                    <span className="sr-only">Loading...</span>
                  </div>
                  <p className="text-muted">Loading consumer list...</p>
                </div>
              ) : (
                <div style={{ marginBottom: "20px" }}>
                  <Select
                    id="consumerName"
                    value={this.state.selectedOption}
                    onChange={this.onChange}
                    options={this.state.consumers}
                    placeholder={`Type to search from consumers...`}
                    components={{ MenuList: this.MenuList }}
                    filterOption={this.filterOption}
                    maxMenuHeight={300}
                    menuPlacement="auto"
                    isSearchable={true}
                    openMenuOnClick={true}
                  />
                </div>
              )}
              {this.isProblemConsumer() && (
                <p
                  id="problemConsumerWarning"
                  className="alert alert-danger util-margin-top-10"
                >
                  There is a known issue with the selected consumer. Please{" "}
                  <a
                    rel="noopener"
                    href="https://support.principal.com/secure/CreateIssueDetails!init.jspa?pid=31203&description=Which%20product%20(from%20your%20initial%20request)%20needs%20access%20to%20the%20Sponsor%20Consumer(s)%3F%3A%0A%0A%0AFor%20Integrate%2C%0AProduction%20Consumer%20Name%3A%20RIS-FSA_Sponsor%0APilot%20Consumer%3A%20Q_AR_RIS-FSA_sponsorsite%0ATest%20Consumer%3A%20AR_RIS-FSA_sponsorsite&summary=Apigee%20Assistance&priority=6&issuetype=6&labels=DISTRIBUTED&labels=HELPDESK&labels=apigee&components=56116"
                  >
                    open a ticket with RIS DevOps - Integrate
                  </a>{" "}
                  for assistance.
                </p>
              )}
              {Utils.isDuplicateConsumer(
                this.props.getStore().consumerName,
                this.state.prodConsumers
              ) && (
                <p
                  id="problemConsumerWarning"
                  className="alert alert-danger util-margin-top-10"
                >
                  The selected consumer has a duplicate entry. Please make sure
                  that there is no duplicate entry in apigee or oauth
                  application. please{" "}
                  <a
                    rel="noopener"
                    href="https://principal.service-now.com/esc?id=sc_cat_item_guide&sys_id=f599dab347ac95d8291c87de536d4316"
                  >
                    open a ticket with API Platform Enablement Team
                  </a>{" "}
                  for assistance.
                </p>
              )}
              {/* {Utils.checkValueInApis(this.props.getStore().consumerName, this.state.testConsumers, this.state.pilotConsumers) && <p id="problemConsumerexists" className="alert alert-danger util-margin-top-10">The selected consumer doesnt exist in all environments, please make sure to create consumer in all environments.
						</p>} */}
              {this.state.consumerNotPresentMainError && (
                <p className="alert alert-danger util-margin-top-10">
                  Selected consumer is not present in the environment (
                  {this.state.singleEnv}). Please add it before proceeding
                  further.
                </p>
              )}
              {this.state.singleEnvError && (
                <p className="alert alert-danger util-margin-top-10">
                  Selected consumer is not present in the environment (
                  {this.state.singleEnv}). Please add it before proceeding
                  further.
                </p>
              )}
              {this.state.multiEnvError && (
                <p className="alert alert-danger util-margin-top-10">
                  Selected consumer is not present in the environment (
                  {this.state.multiEnv}). Please add it before proceeding
                  further.
                </p>
              )}

              {this.state.singleProductEnvError && (
                <p className="alert alert-danger util-margin-top-10">
                  Selected product ({this.props.getStore().productName}) for the
                  consumer is associated in all three environments.
                </p>
              )}
              {this.state.multiProductEnvError && (
                <p className="alert alert-danger util-margin-top-10">
                  Selected product ({this.props.getStore().productName}) for the
                  consumer is associated in the environment (
                  {this.state.multiProductEnv}).
                </p>
              )}
              {this.state.productPendingError && (
                <p className="alert alert-danger util-margin-top-10">
                  Selected product ({this.props.getStore().productName}) is
                  already associated with the consumer and is currently in
                  pending status for approval in the following environment(s):{" "}
                  {this.state.productPendingEnvs}. Please open a ticket with{" "}
                  <a
                    rel="noopener"
                    href="https://principal.service-now.com/esc?id=sc_cat_item_guide&sys_id=f599dab347ac95d8291c87de536d4316"
                  >
                    API Platform Enablement Team
                  </a>{" "}
                  for approval.
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ConsumerName;
